<div class="modal-heading modal-heading-1">
    <div class="label_name">
        {{ 'ANSWER_EXPLANATION.ANSWER_EXPLANATION' | translate }}
        <div class="modal-close-x" (click)="closeModal()"><fa-icon [icon]="['fas','times']"></fa-icon></div>
    </div>
</div>

<div class="modal-body center">
    <div class="well center">
        <div class="text-sm grey">{{ 'ANSWER_EXPLANATION.ANSWER' | translate }}</div>
        <div [innerHTML]="choice.AnswerText | unsafeHtml" class="text-lg RenderMath AnswerText AnswerTextTeacher spacer-sm"></div>
    </div>

    <div class="text-sm grey">{{ 'ANSWER_EXPLANATION.EXPLANATION' | translate }}</div>
    <div class="text-md spacer-sm RenderMath" [innerHTML]="choice.Explanation | unsafeHtml"></div>
</div>

<div class="modal-footer">
    <a class="btn btn-primary" (click)="closeModal()">{{ 'ANSWER_EXPLANATION.CLOSE' | translate }}</a>
</div>